(function () {
  'use strict';

  var KEY = 'niranja_wishlist';

  /* ── Storage ──────────────────────────────────────────────── */
  function getHandles() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }

  function saveHandles(arr) {
    localStorage.setItem(KEY, JSON.stringify(arr));
    refreshUI();
    document.dispatchEvent(new CustomEvent('niranja:wishlist:updated', { detail: { count: arr.length } }));
  }

  function hasHandle(h) { return getHandles().indexOf(h) !== -1; }

  function addHandle(h) {
    var list = getHandles();
    if (list.indexOf(h) === -1) saveHandles(list.concat([h]));
  }

  function removeHandle(h) { saveHandles(getHandles().filter(function (x) { return x !== h; })); }

  function toggleHandle(h) { hasHandle(h) ? removeHandle(h) : addHandle(h); }

  /* ── UI refresh ───────────────────────────────────────────── */
  function refreshUI() {
    var count = getHandles().length;

    document.querySelectorAll('.niranja-wishlist-count').forEach(function (el) {
      if (count > 0) {
        el.textContent = count;
        el.removeAttribute('hidden');
        el.style.display = 'flex';
      } else {
        el.setAttribute('hidden', '');
        el.style.display = 'none';
      }
    });

    document.querySelectorAll('[data-wishlist-handle]').forEach(function (btn) {
      var active = hasHandle(btn.dataset.wishlistHandle);
      btn.classList.toggle('niranja-wishlist-btn--active', active);
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
      var label = btn.querySelector('.niranja-wishlist-label');
      if (label) label.textContent = active ? 'Remove from Wishlist' : 'Add to Wishlist';
    });
  }

  /* ── Click delegation ─────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-handle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggleHandle(btn.dataset.wishlistHandle);
  });

  /* ── Wishlist page renderer ───────────────────────────────── */
  function formatMoney(cents) {
    var symbol = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'GBP') ? '£' : '£';
    return symbol + (cents / 100).toFixed(2);
  }

  function buildCard(product) {
    var v        = product.variants[0];
    var imgUrl   = product.images.length ? product.images[0] : '';
    var imgHtml  = imgUrl
      ? '<img src="' + imgUrl + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy">'
      : '<div class="niranja-wl-card__no-img"></div>';
    var saleHtml = (v.compare_at_price && v.compare_at_price > v.price)
      ? '<s class="niranja-wl-compare">' + formatMoney(v.compare_at_price) + '</s> '
      : '';

    return '<div class="niranja-wl-card">'
      + '<div class="niranja-wl-card__img-wrap">'
      +   '<a href="/products/' + product.handle + '">' + imgHtml + '</a>'
      +   '<button'
      +     ' class="niranja-wishlist-btn niranja-wishlist-btn--card niranja-wishlist-btn--active"'
      +     ' data-wishlist-handle="' + product.handle + '"'
      +     ' aria-label="Remove from wishlist"'
      +     ' title="Remove from wishlist">'
      +     '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">'
      +       '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>'
      +     '</svg>'
      +   '</button>'
      + '</div>'
      + '<div class="niranja-wl-card__info">'
      +   '<a href="/products/' + product.handle + '" class="niranja-wl-card__title">' + product.title + '</a>'
      +   '<p class="niranja-wl-card__price">' + saleHtml + formatMoney(v.price) + '</p>'
      +   '<a href="/products/' + product.handle + '" class="button button--secondary niranja-wl-card__view-btn">View Product</a>'
      + '</div>'
      + '</div>';
  }

  function renderPage() {
    var grid    = document.getElementById('niranja-wishlist-grid');
    var empty   = document.getElementById('niranja-wishlist-empty');
    var loading = document.getElementById('niranja-wishlist-loading');
    if (!grid) return;

    var handles = getHandles();
    if (loading) loading.hidden = true;

    if (!handles.length) {
      if (empty) empty.hidden = false;
      return;
    }

    var promises = handles.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
    });

    Promise.all(promises).then(function (products) {
      var html = products
        .filter(function (p) { return p !== null; })
        .map(buildCard)
        .join('');

      grid.innerHTML = html;
      refreshUI();

      // Live-remove card when item is un-wishlisted on the wishlist page
      document.addEventListener('niranja:wishlist:updated', function () {
        var current = getHandles();
        grid.querySelectorAll('.niranja-wl-card').forEach(function (card) {
          var btn = card.querySelector('[data-wishlist-handle]');
          if (btn && current.indexOf(btn.dataset.wishlistHandle) === -1) {
            card.remove();
          }
        });
        if (!grid.children.length && empty) empty.hidden = false;
      });
    });
  }

  /* ── Init ─────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    refreshUI();
    renderPage();
  });

  window.NiranjaWishlist = {
    getHandles: getHandles,
    hasHandle: hasHandle,
    addHandle: addHandle,
    removeHandle: removeHandle,
    toggleHandle: toggleHandle
  };
})();
